
import {Icon, IconNode} from "lucide-react";
import React from "react";


const PenToSquareIconNode: IconNode = [
    [
        "path",
        {
            d: "M9.85416 1.89376L10.1062 2.14584C10.3021 2.34167 10.3021 2.65834 10.1062 2.85209L9.49999 3.46042L8.53957 2.50001L9.14582 1.89376C9.34166 1.69792 9.65832 1.69792 9.85207 1.89376H9.85416ZM5.03749 6.00417L7.83332 3.20626L8.79374 4.16667L5.99582 6.96251C5.93541 7.02292 5.86041 7.06667 5.77916 7.08959L4.56041 7.43751L4.90832 6.21876C4.93124 6.13751 4.97499 6.06251 5.03541 6.00209L5.03749 6.00417ZM8.43957 1.18751L4.32916 5.29584C4.14791 5.47709 4.01666 5.70001 3.94791 5.94376L3.35207 8.02709C3.30207 8.20209 3.34999 8.38959 3.47916 8.51876C3.60832 8.64792 3.79582 8.69584 3.97082 8.64584L6.05416 8.05001C6.29999 7.97917 6.52291 7.84792 6.70207 7.66876L10.8125 3.56042C11.3979 2.97501 11.3979 2.02501 10.8125 1.43959L10.5604 1.18751C9.97499 0.602089 9.02499 0.602089 8.43957 1.18751ZM2.49999 2.00001C1.48749 2.00001 0.666656 2.82084 0.666656 3.83334V9.50001C0.666656 10.5125 1.48749 11.3333 2.49999 11.3333H8.16666C9.17916 11.3333 9.99999 10.5125 9.99999 9.50001V7.16667C9.99999 6.88959 9.77707 6.66667 9.49999 6.66667C9.22291 6.66667 8.99999 6.88959 8.99999 7.16667V9.50001C8.99999 9.96042 8.62707 10.3333 8.16666 10.3333H2.49999C2.03957 10.3333 1.66666 9.96042 1.66666 9.50001V3.83334C1.66666 3.37292 2.03957 3.00001 2.49999 3.00001H4.83332C5.11041 3.00001 5.33332 2.77709 5.33332 2.50001C5.33332 2.22292 5.11041 2.00001 4.83332 2.00001H2.49999Z",
            fill: "#6A1519",
            key: "path0PenToSquare",
        }
    ]
];

interface PenToSquareProps {
    size?: string | number;
    className?: string;
}

export default function PenToSquare({ size, className }: PenToSquareProps) {
    return (
        <Icon iconNode={PenToSquareIconNode} size={size} className={className} fill="#6A1519" color="transparent" viewBox="0 0 12 12" />
    );
}
